import React, { useState } from "react";
import ServiceList from "./components/Service";
import ServiceContent from "./components/ServiceContent";
import "./ServicePage.css";
import { Helmet } from "react-helmet";
import ServiceBlock from "./components/ServiceBlock";
import {
  FaCode,
  FaPaintBrush,
  FaCube,
  FaBullhorn,
  FaRobot,
  FaBug,
} from "react-icons/fa";
import { useCursor } from "../../shared/config/cursorProvider";

const servicesData = [
  {
    id: 1,
    icon: FaCode,
    title: "Web Development",
    description:
      "Crafting responsive and user-friendly websites tailored to your unique business needs. From robust e-commerce platforms to interactive web applications, we bring your digital vision to life.",
    keyFeatures: [
      "Customized Web Solutions",
      "Responsive Designs",
      "E-commerce Development",
    ],
    moreInfo:
      "Transform your online presence with our expert web development services.",
  },
  {
    id: 2,
    icon: FaPaintBrush,
    title: "UI/UX Design",
    description:
      "Elevate your brand aesthetics and user satisfaction with our UI/UX design services. We focus on creating visually stunning and intuitively designed interfaces that leave a lasting impression.",
    keyFeatures: [
      "User-Centric Design",
      "Engaging Visuals",
      "Brand Aesthetics",
    ],
    moreInfo: "Crafting interfaces that captivate and engage your audience.",
  },
  {
    id: 3,
    icon: FaCube,
    title: "Digital Marketing",
    description:
      "Navigate the digital landscape with confidence through our comprehensive digital marketing services. We employ data-driven strategies to enhance your online visibility, attract targeted audiences, and amplify your brand.",
    keyFeatures: [
      "Data-Driven Strategies",
      "Online Visibility",
      "Targeted Audience Engagement",
    ],
    moreInfo:
      "Boost your brand's presence across diverse digital channels with our digital marketing expertise.",
  },
  {
    id: 4,
    icon: FaBullhorn,
    title: "3D Asset Creation and Integration",
    description:
      "Immerse your audience in a three-dimensional world with our 3D asset creation and integration services. From lifelike animations to interactive 3D models, we push the boundaries of visual storytelling.",
    keyFeatures: [
      "Interactive 3D Models",
      "Lifelike Animations",
      "Visual Storytelling",
    ],
    moreInfo:
      "Explore the captivating possibilities of 3D with our expert services.",
  },
  {
    id: 5,
    icon: FaRobot,
    title: "Software Testing",
    description:
      "Quality assurance is at the core of what we do. Our software testing services ensure that your applications and systems perform flawlessly. We guarantee the reliability and functionality of your software, offering a seamless experience for your end-users.",
    keyFeatures: [
      "Quality Assurance",
      "Reliability Testing",
      "Functional Testing",
    ],
    moreInfo:
      "Ensure the flawless performance of your software with our expert testing services.",
  },
  {
    id: 6,
    icon: FaBug,
    title: "AI Integration",
    description:
      "Embrace the future of technology with our AI integration services. We leverage artificial intelligence to enhance the efficiency of your processes, automate tasks, and provide intelligent solutions that propel your business into the next era.",
    keyFeatures: [
      "Efficient Automation",
      "Intelligent Solutions",
      "Advanced AI Integration",
    ],
    moreInfo:
      "Stay ahead with our cutting-edge AI integration services tailored to your business needs.",
  },
];

const services = [
  {
    id: 1,
    title: "Web Development",
    description: "Creating stunning and responsive websites for your business.",
  },
  {
    id: 2,
    title: "UI/UX Design",
    description:
      "Designing intuitive and visually appealing user interfaces and experiences.",
  },
  {
    id: 3,
    title: "Digital Marketing",
    description:
      "Promoting your brand through effective digital marketing strategies.",
  },
  {
    id: 4,
    title: "3D Assets Creation and Integration",
    description:
      "Developing high-quality 3D assets and integrating them into your projects.",
  },
  {
    id: 5,
    title: "Software Testing",
    description:
      "Ensuring the reliability and functionality of your software through rigorous testing.",
  },
  {
    id: 6,
    title: "AI Integration",
    description:
      "Incorporating artificial intelligence to enhance the capabilities of your applications.",
  },
];

const ServicePage = () => {
  const [selectedService, setSelectedService] = useState(servicesData[0]);
  const metaDescription = servicesData[0]?.description || "Default meta description";
  const cursorPosition = useCursor()

  const handleServiceSelect = (service) => {
    setSelectedService(service);
  };

  return (
    <div>
      <Helmet>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <div className="custom-1" style={{ left: cursorPosition.x, top: cursorPosition.y }}></div>
      <div className="custom-cursor" style={{ left: cursorPosition.x, top: cursorPosition.y }}></div>
      <div className="service-container">
        <h1>Discover Our Service Catalog</h1>
        <p className="tag1">Web development</p>
        <p className="tag2">Digital Marketing</p>
        <p className="tag3">UI/UX</p>
        <p className="tag4">3D Asset Creation and Integration</p>
        <p className="tag5">Artificial Intelligence Integration</p>
        <p className="tag6">Software Testing</p>
      </div>
      <div className="services-container">
        {services.map((service) => (
          <ServiceBlock key={service.id} service={service} />
        ))}
      </div>
      <div className="category-of-services">
        <h1>Categories of Services</h1>
        <p>
          Welcome to Zivotics, where innovation meets excellence in a spectrum
          of services designed to elevate your digital presence. Our commitment
          to delivering cutting-edge solutions is reflected in the diverse
          categories of services we offer:
        </p>
      </div>
      <div className="servive-page-container">
        <ServiceList
          services={servicesData}
          selectedService={selectedService}
          onSelect={handleServiceSelect}
        />
        <ServiceContent service={selectedService} />
      </div>
    </div>
  );
};

export default ServicePage;
